<script setup lang="ts">
import NavbarMobileMainNavigation from '@layout/nav-v2/mobile/components/NavbarMobileMainNavigation.vue';
import NavbarMobilePlus from '@layout/nav-v2/mobile/components/NavbarMobilePlus.vue';
import { useNavbarStore } from '@stores/layout/useNavbarStore';
import { storeToRefs } from 'pinia';

const navbarStore = useNavbarStore();
const { isPlusMenuOpen } = storeToRefs(navbarStore);
const { closePlusMenu } = navbarStore;
</script>

<template>
  <div
    :class="[
      'navbar-mobile',
      'fixed bottom-0 z-[101]',
      'w-full h-16',
      'flex lg:hidden',
    ]"
  >
    <NavbarMobileMainNavigation class="navbar-mobile__main flex-1" />

    <NavbarMobilePlus
      class="!z-[-1]"
      :is-open="isPlusMenuOpen"
      @close="closePlusMenu"
    />
  </div>
</template>

<style scoped lang="scss">
@use '@styles/variables' as *;

.navbar-mobile {
  &__main {
    background-color: $colorWhite;
    border-top: 1px solid $colorGray;
  }
}
</style>
